import { Button } from '@moniebook-web/components/atoms/button';
import { APP_BACKGROUND_JOBS, backgroundJob } from '@register-ui/utils';
import { STOCK_SYNC_STATUS, type StockSyncStatus } from './types';

interface Props {
    status: StockSyncStatus;
}

const contentMap = {
    [STOCK_SYNC_STATUS.STARTED]: 'Register sync in progress',
    [STOCK_SYNC_STATUS.SUCCESS]: 'Register sync successful.',
    [STOCK_SYNC_STATUS.FAILED]: 'Register sync failed.',
    [STOCK_SYNC_STATUS.IDLE]: undefined,
};

export function StockSyncIndicator({ status }: Readonly<Props>) {
    const content = contentMap[status];

    const handleRetry = async () => {
        backgroundJob.runJobManually(APP_BACKGROUND_JOBS.ITEM_STOCK_SYNC);
    };

    return (
        <div className='flex items-center justify-between'>
            <div className='flex gap-16 px-8'>{content}</div>

            {status === STOCK_SYNC_STATUS.FAILED && (
                <Button label='Retry' theme='tertiary' onClick={handleRetry} />
            )}

            {status === STOCK_SYNC_STATUS.STARTED && (
                <div className='h-4 w-120 overflow-hidden rounded-8 bg-feedback-default-ghost-pressed'>
                    <div className='h-full animate-banner-progress bg-action-default-filled-default' />
                </div>
            )}
        </div>
    );
}
